import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { PRICE_ANCHOR } from '../lib/config';
type CtaButtonProps = {
  children: React.ReactNode;
  /** Por defecto hace scroll suave a la sección de precio. */
  href?: string;
  /** Línea de confianza obligatoria debajo del botón. */
  microcopy?: string;
  size?: 'lg' | 'xl';
  tone?: 'light' | 'dark';
  align?: 'center' | 'start';
  className?: string;
};
export function CtaButton({
  children,
  href = PRICE_ANCHOR,
  microcopy = 'Pago seguro · Descarga inmediata · Garantía de 7 días · 100% digital',
  size = 'lg',
  tone = 'light',
  align = 'center',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'xl' ? 'px-8 py-5 text-base sm:text-lg' : 'px-7 py-4 text-sm sm:text-base';
  return <div className={`flex w-full flex-col ${align === 'center' ? 'items-center' : 'items-start'} ${className}`} data-id="element-91" data-mp="19b1ltv8ci82h">
      <a href={href} className={`group inline-flex w-full items-center justify-center gap-2.5 rounded-card bg-gold-grad font-semibold text-ink shadow-card transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lift focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/50 focus-visible:ring-offset-2 sm:w-auto ${sizing}`} data-id="element-92" data-mp="159zstw50us8y">
        <span className="text-center" data-id="element-93" data-mp="3f07017t4q32g">{children}</span>
        <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-94" data-mp="3jxqfgb1kclvz" />
      </a>
      {microcopy && <p className={`mt-3 text-xs leading-relaxed ${align === 'center' ? 'text-center' : ''} ${tone === 'dark' ? 'text-ivory/60' : 'text-ink/60'}`} data-id="element-95" data-mp="3swtxdbozuv8w">
          {microcopy}
        </p>}
    </div>;
}